import React from "react";
import Grid from "@mui/material/Grid";
import BackButton from "../BackButton";
import Loader from "../Loader/Loader";

function LoaderScreen() {
  return (
    <>
      <BackButton />
      <Grid
        container
        direction={"row"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
        sx={{ minHeight: "100vh" }}
      >
        <Grid item>
          <Loader />
        </Grid>
      </Grid>
    </>
  );
}

export default LoaderScreen;
